var render, staticRenderFns
import script from "./ReplyBox.vue?vue&type=script&lang=tsx&"
export * from "./ReplyBox.vue?vue&type=script&lang=tsx&"
import style0 from "./ReplyBox.vue?vue&type=style&index=0&id=a82197aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82197aa",
  null
  
)

export default component.exports